/**
* Events Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Events Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'events-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.events-grid .title-link' ).mouseover( function() {
        $( this ).closest( '.col' ).find( '.learn-more' ).addClass( 'is-hovered' );
      } ).mouseleave( function() {
        $( this ).closest( '.col' ).find( '.learn-more' ).removeClass( 'is-hovered' );
      } );

      $( '.events-grid .learn-more' ).mouseover( function() {
        $( this ).closest( '.col' ).find( '.title-link' ).addClass( 'underline' );
      } ).mouseleave( function() {
        $( this ).closest( '.col' ).find( '.title-link' ).removeClass( 'underline' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'events-grid', COMPONENT );
} )( app );
